export function formatToYen(value: string | "") {
  const formatValue = !Number.isNaN(parseInt(value))
    ? `￥ ${value}`.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
    : `￥ `;
  return formatValue;
}
